/**
 * Created by PuTi(编程即菩提) 9/1/17.
 */

var nb = require('../../nb');
module.exports = nb.define({
    parent: require('../../view/Page'),
    slot: {
        content: ['html', {
            $type: require('./view/Content'),
            $model:'content'
        }]
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/page/order/Page.js
// module id = 673
// module chunks = 3